export default "__VITE_ASSET__DXc9zJmA__"